import { VRating } from 'vuetify/lib/components/VRating';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('InfoLabel',{attrs:{"label":_vm.field.label}},[(_vm.hasStarRating)?_c(VRating,{attrs:{"readonly":"","half-increments":"","hover":"","length":_vm.field.starCount,"value":_vm.value}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }